/* eslint-disable */
// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,add_pb_suffix,ts_nocheck,eslint_disable
// @generated from protobuf file "user/iam/models.proto" (package "rd.user.iam", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../google/protobuf/timestamp_pb";
import { Any } from "../../google/protobuf/any_pb";
/**
 * CachedAnalyzeIamPolicyRes caches a call to asset.AnalyzeIamPolicy. Not
 * intended for use outside this package.
 *
 * @generated from protobuf message rd.user.iam.CachedAnalyzeIamPolicyRes
 */
export interface CachedAnalyzeIamPolicyRes {
    /**
     * Res is the cached api response. Its type will be
     * *assetpb.AnalyzeIamPolicyResponse.
     *
     * @generated from protobuf field: google.protobuf.Any res = 1
     */
    res?: Any;
    /**
     * Mac is used to sign the message.
     *
     * @generated from protobuf field: bytes mac = 2
     */
    mac: Uint8Array;
    /**
     * FetchedAt is used to determine the cache entry's age and whether it should
     * be invalidated.
     *
     * @generated from protobuf field: google.protobuf.Timestamp fetched_at = 3
     */
    fetchedAt?: Timestamp;
}
/**
 * Role enumerates our GCP custom roles. Enum names must be of the form
 * `ROLE_<iam role name>`. All custom role names begin with `rd_iam_`.
 *
 * @generated from protobuf enum rd.user.iam.Role
 */
export enum Role {
    /**
     * @generated from protobuf enum value: ROLE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: ROLE_RD_IAM_ENG = 1;
     */
    RD_IAM_ENG = 1,
    /**
     * @generated from protobuf enum value: ROLE_RD_IAM_INTERNAL_APP_BILLING = 2;
     */
    RD_IAM_INTERNAL_APP_BILLING = 2,
    /**
     * @generated from protobuf enum value: ROLE_RD_IAM_INTERNAL_APP_TESTABLE = 3;
     */
    RD_IAM_INTERNAL_APP_TESTABLE = 3,
    /**
     * @generated from protobuf enum value: ROLE_RD_IAM_INTERNAL_APP_GO_LIVE = 4;
     */
    RD_IAM_INTERNAL_APP_GO_LIVE = 4,
    /**
     * @generated from protobuf enum value: ROLE_RD_IAM_INTERNAL_APP_ACQUISITION = 5;
     */
    RD_IAM_INTERNAL_APP_ACQUISITION = 5,
    /**
     * @generated from protobuf enum value: ROLE_RD_IAM_INTERNAL_APP_IMPLEMENTATION = 6;
     */
    RD_IAM_INTERNAL_APP_IMPLEMENTATION = 6,
    /**
     * @generated from protobuf enum value: ROLE_RD_IAM_INTERNAL_APP_CX_INTEGRATIONS = 7;
     */
    RD_IAM_INTERNAL_APP_CX_INTEGRATIONS = 7,
    /**
     * @generated from protobuf enum value: ROLE_RD_IAM_INTERNAL_APP_SUPPORT = 8;
     */
    RD_IAM_INTERNAL_APP_SUPPORT = 8,
    /**
     * @generated from protobuf enum value: ROLE_RD_IAM_INTERNAL_APP_MESSAGING = 9;
     */
    RD_IAM_INTERNAL_APP_MESSAGING = 9,
    /**
     * @generated from protobuf enum value: ROLE_RD_IAM_INTERNAL_APP_AGREEMENTS = 10;
     */
    RD_IAM_INTERNAL_APP_AGREEMENTS = 10,
    /**
     * @generated from protobuf enum value: ROLE_RD_IAM_INTERNAL_APP_DATA_IN = 11;
     */
    RD_IAM_INTERNAL_APP_DATA_IN = 11
}
// @generated message type with reflection information, may provide speed optimized methods
class CachedAnalyzeIamPolicyRes$Type extends MessageType<CachedAnalyzeIamPolicyRes> {
    constructor() {
        super("rd.user.iam.CachedAnalyzeIamPolicyRes", [
            { no: 1, name: "res", kind: "message", T: () => Any },
            { no: 2, name: "mac", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 3, name: "fetched_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<CachedAnalyzeIamPolicyRes>): CachedAnalyzeIamPolicyRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.mac = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<CachedAnalyzeIamPolicyRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CachedAnalyzeIamPolicyRes): CachedAnalyzeIamPolicyRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Any res */ 1:
                    message.res = Any.internalBinaryRead(reader, reader.uint32(), options, message.res);
                    break;
                case /* bytes mac */ 2:
                    message.mac = reader.bytes();
                    break;
                case /* google.protobuf.Timestamp fetched_at */ 3:
                    message.fetchedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.fetchedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CachedAnalyzeIamPolicyRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Any res = 1; */
        if (message.res)
            Any.internalBinaryWrite(message.res, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bytes mac = 2; */
        if (message.mac.length)
            writer.tag(2, WireType.LengthDelimited).bytes(message.mac);
        /* google.protobuf.Timestamp fetched_at = 3; */
        if (message.fetchedAt)
            Timestamp.internalBinaryWrite(message.fetchedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.user.iam.CachedAnalyzeIamPolicyRes
 */
export const CachedAnalyzeIamPolicyRes = new CachedAnalyzeIamPolicyRes$Type();
